/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumHyperlinkTarget {
	Self  = '_self',
	Blank = '_blank'
}
